import { getClassColor } from '@mitsubishi/shared/ui';
import { getColorWithOpacity } from '@mitsubishi/utils';

export const WORKING_CONDITION_OPACITY: number[] = [0.6, 0.4, 0.2, 0.1];

/** Working conditions of a subcategory share its class color and are told apart by opacity. */
export function getWorkingConditionColor(classId: number | undefined, wcIndex: number): string | undefined {
  const color = getClassColor(classId);
  if (!color) {
    return undefined;
  }

  const opacity = WORKING_CONDITION_OPACITY[wcIndex % WORKING_CONDITION_OPACITY.length];
  return getColorWithOpacity(color, opacity);
}
